<div class="flex min-h-[calc(100vh-48px)] flex-col gap-5 bg-light-color px-6 py-6 font-base text-dark-color">
  <header class="flex flex-col gap-4 rounded-2xl bg-gradient-to-r from-[var(--primary-color)] via-[var(--primary-color-hover)] to-[var(--second-color)] px-6 py-6 text-light-color shadow-[0_14px_40px_var(--box-shadow-color)] md:flex-row md:items-start md:justify-between md:gap-6">
    <div class="flex flex-col gap-2">
      <p class="text-xs uppercase tracking-[0.12em] text-light-color/80">Relatório</p>
      <h1 class="text-2xl font-semibold leading-tight">Resumo do disparo</h1>
      <p class="max-w-3xl text-sm text-light-color/90">
        Veja o status do envio, filtros aplicados e acompanhe as mensagens enviadas.
      </p>
    </div>
    <div class="grid grid-cols-2 gap-3 text-sm md:grid-cols-2">
      <div class="rounded-xl bg-white/10 px-4 py-3 shadow">
        <p class="m-0 text-xs uppercase tracking-[0.12em] text-light-color/80">Disparos</p>
        <strong class="text-lg">{{ dataReport.resumo.disparos || 0 }}</strong>
      </div>
      <div class="rounded-xl bg-white/10 px-4 py-3 shadow">
        <p class="m-0 text-xs uppercase tracking-[0.12em] text-light-color/80">Status</p>
        <strong class="text-lg">{{ dataReport.resumo.status || '-' }}</strong>
      </div>
    </div>
  </header>

  <section class="flex flex-col gap-4 rounded-xl border border-border-color bg-white px-5 py-5 shadow-[0_12px_36px_var(--box-shadow-color)]">
    <div class="grid grid-cols-1 gap-3 md:grid-cols-3">
      <div class="flex flex-col gap-1 rounded-base border border-border-color bg-light-color/60 px-3 py-2 text-sm">
        <span class="text-dark-color/70">Arquivo</span>
        <strong class="text-dark-color break-words">{{ dataReport.resumo.fileName || '-' }}</strong>
      </div>
      <div class="flex flex-col gap-1 rounded-base border border-border-color bg-light-color/60 px-3 py-2 text-sm">
        <span class="text-dark-color/70">Coluna selecionada</span>
        <strong class="text-dark-color break-words">{{ dataReport.resumo.columnSelected || '-' }}</strong>
      </div>
      <div class="flex flex-col gap-1 rounded-base border border-border-color bg-light-color/60 px-3 py-2 text-sm">
        <span class="text-dark-color/70">Envio em fins de semana</span>
        <div class="flex gap-2">
          <span class="rounded-full bg-primary-color/10 px-3 py-1 text-xs font-semibold text-primary-color">
            Sáb: {{ dataReport.resumo.selectedSaturday ? 'SIM' : 'NÃO' }}
          </span>
          <span class="rounded-full bg-primary-color/10 px-3 py-1 text-xs font-semibold text-primary-color">
            Dom: {{ dataReport.resumo.selectedSunday ? 'SIM' : 'NÃO' }}
          </span>
        </div>
      </div>
    </div>

    <div class="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
      <div class="flex flex-wrap items-center gap-2 text-sm text-dark-color">
        <span class="inline-flex items-center gap-2 rounded-full bg-green-100 px-3 py-1 text-xs font-semibold text-green-700">
          <span class="h-2 w-2 rounded-full bg-green-600"></span> Sucesso
        </span>
        <span class="inline-flex items-center gap-2 rounded-full bg-yellow-100 px-3 py-1 text-xs font-semibold text-yellow-700">
          <span class="h-2 w-2 rounded-full bg-yellow-500"></span> Pendente
        </span>
        <span class="inline-flex items-center gap-2 rounded-full bg-red-100 px-3 py-1 text-xs font-semibold text-red-700">
          <span class="h-2 w-2 rounded-full bg-red-500"></span> Erro
        </span>
        <span class="inline-flex items-center gap-2 rounded-full bg-gray-200 px-3 py-1 text-xs font-semibold text-gray-700">
          <span class="h-2 w-2 rounded-full bg-gray-500"></span> Bloqueado
        </span>
      </div>

      <div class="flex flex-col gap-2 md:flex-row md:items-center md:gap-3">
        <select
          class="rounded-base border border-border-color bg-white px-3 py-2 text-sm outline-none focus:border-primary-color"
          (change)="handleChangeFilter($event)">
          <option value="success">Requisições enviadas com sucesso</option>
          <option value="Pendente">Requisições pendentes</option>
        </select>
        <button
          type="button"
          class="inline-flex items-center gap-2 rounded-base bg-primary-color px-4 py-2 text-sm font-semibold text-white shadow transition hover:bg-primary-hover"
          (click)="exportarDados()">
          <mat-icon>file_download</mat-icon>
          Exportar
        </button>
      </div>
    </div>
  </section>

  <section class="rounded-xl border border-border-color bg-white px-4 py-4 shadow-[0_12px_36px_var(--box-shadow-color)]">
    <div
      class="grid grid-cols-1 gap-3 md:grid-cols-2 lg:grid-cols-3 max-h-[70vh] overflow-y-auto"
      (scroll)="onScroll($event)">
      <div
        class="flex min-w-0 flex-col gap-2 rounded-xl border border-border-color p-4 transition overflow-hidden"
        *ngFor="let send of displayedMessages"
        [attr.title]="send.mensagem || ''"
        [ngClass]="{
          'bg-green-50 border-green-200': send.status === 'success',
          'bg-yellow-50 border-yellow-200': send.status === 'Pendente',
          'bg-red-50 border-red-200': send.status === 'ERRO',
          'bg-gray-100 border-gray-200': send.status === 'BLOQUEADO'
        }">
        <div class="flex flex-col gap-1 sm:flex-row sm:items-start sm:justify-between sm:gap-2">
          <div class="flex min-w-0 flex-col">
            <span class="text-sm font-semibold text-dark-color break-words">{{ send.numero }}</span>
            <span class="text-xs text-dark-color/70">Mensagem</span>
          </div>
          <span class="text-xs sm:text-sm text-right" [ngSwitch]="send.status">
            <span *ngSwitchCase="'Pendente'">⏳</span>
            <span *ngSwitchCase="'ERRO'">⚠️</span>
            <span *ngSwitchCase="'success'" class="text-green-700 font-semibold">{{ send.hourSend }} ✓✓</span>
            <span *ngSwitchCase="'BLOQUEADO'">🚫</span>
          </span>
        </div>
        <p class="m-0 text-sm text-dark-color/80 break-words">
          {{
            send.mensagem.length > messagePreviewLength
              ? (send.mensagem | slice: 0:messagePreviewLength) + '...'
              : send.mensagem
          }}
        </p>
      </div>

      <div *ngIf="isLoadingMore" class="col-span-full text-center text-sm text-dark-color/70 py-4">
        Carregando mais...
      </div>
    </div>
  </section>
</div>
